import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

export function RequireAuth({ children }: { children: ReactNode }) {
  const token = localStorage.getItem("@user");

  return <>{token ? children : <Navigate to={"/login"} replace />}</>;
}
